__turbopack_context__.v({
  "comment": "RepairRequestReasonSummary-module-scss-module__WGWcXq__comment",
  "list": "RepairRequestReasonSummary-module-scss-module__WGWcXq__list",
  "wrapper": "RepairRequestReasonSummary-module-scss-module__WGWcXq__wrapper",
});
